/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import store from "./store";
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import VueMobileDetection from 'vue-mobile-detection'
import Vuesax from 'vuesax'
import "./axios";
// router setup
import router from './routes/router';

import 'vuesax/dist/vuesax.css'
import VueMaskDirective  from 'v-mask'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueMobileDetection)
Vue.directive('mask', VueMaskDirective)
Vue.use(Vuesax);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
